import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { updateNavTitle, fetchImage } from "../../actions";
import { connect } from "react-redux";
import "./imagePortalStyle.css";

class Image extends React.Component {
  getImage() {
    //if it hasn't retrieved data yet then do so from firestore
    if (!this.props.isCached) {
      console.log(
        `[Image] >>> Getting image ${this.props.match.params.imageName} from firestore!!!`
      );
      this.props.fetchImage(this.props.match.params.imageName);
    }
  }

  componentDidMount() {
    console.log("[IMAGE] COMPONENTDIDMOUNT");

    this.props.updateNavTitle(this.props.match.params.imageName, true);

    //get image
    this.getImage();
  }

  render() {
    console.log(
      "[IMAGE] RENDER",
      this.props.image,
      this.props.isCached,
      this.props.match.params.imageName
    );
    if (this.props.image) {
      let { image } = this.props;
      let imageIssueData;
      if (image.memoType === "SP") {
        imageIssueData = JSON.parse(image.reasonArr).map((reason, index) => {
          return (
            <div
              className="image-info-data"
              key={index}
              style={{ padding: "10px 0" }}
            >
              <Typography variant="h6" component="h6">
                Issue:{" "}
                <span style={{ fontWeight: "300" }}>{reason.reason}</span>
              </Typography>

              <Typography variant="h6" component="h6">
                Quantity:{" "}
                <span style={{ fontWeight: "300" }}>{reason.quantity}</span>
              </Typography>

              <Typography variant="h6" component="h6">
                Part: <span style={{ fontWeight: "300" }}>{reason.part}</span>
              </Typography>
            </div>
          );
        });
      } else if (image.memoType === "RET") {
        imageIssueData = (
          <div>
            <div className="image-info-data">
              <Typography variant="h6" component="h6">
                Issue:{" "}
              </Typography>
              <div style={{ fontSize: "20px" }}>{image.reason}</div>
            </div>
            <div className="image-info-data">
              <Typography variant="h6" component="h6">
                Quantity:{" "}
              </Typography>
              <div style={{ fontSize: "20px" }}>{image.quantity}</div>
            </div>
          </div>
        );
      }

      return (
        <div>
          <Grid container>
            <Grid item md={12} lg={9}>
              <div className="image-container">
                <img
                  className="image-display"
                  src={this.props.image.imageUrl}
                  alt={image.name}
                />
              </div>
            </Grid>
            <Grid item md={12} lg={3}>
              <div className="image-info-container">
                <div className="image-info-data">
                  <Typography variant="h4" component="h4">
                    {image.memoId}
                  </Typography>
                  <Typography variant="body2">
                    {image.createdAt.slice(0, 10)}
                  </Typography>
                </div>
                {imageIssueData}
                <div className="image-info-data">
                  <Typography variant="h6" component="h6">
                    Supplier:{" "}
                  </Typography>
                  <div style={{ fontSize: "20px" }}>{image.supplierId}</div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      );
    } else {
      return <div>loading</div>;
    }
  }
}

function mapStateToProps(state, ownProps) {
  return {
    image: state.imageList[ownProps.match.params.imageName],
    isCached: state.imageList.isCached
  };
}

Image.propTypes = {
  match: PropTypes.object,
  image: PropTypes.object,
  isCached: PropTypes.bool,
  fetchImage: PropTypes.func,
  updateNavTitle: PropTypes.func
};

export default connect(mapStateToProps, { fetchImage, updateNavTitle })(Image);
